export const defaultValues = {
  name: '',
  description: '',
  logo: null,
  teamManagers: [],
};
